import React from 'react';
import { COPILOT_PANEL_WIDTH } from '@components/Copilot/constants';
import { AiMagic } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { Box } from '@mui/material';

interface IDefaultPromptItem {
  prompt: string;
  onClick: () => void;
}

const DefaultPromptItem: React.FC<IDefaultPromptItem> = ({ prompt, onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      cursor: 'pointer',
      width: '100%',
      maxWidth: COPILOT_PANEL_WIDTH - 48,
      ...flex.itemsStart,
      gap: 0.5,
      px: 1.5,
      py: 2,
      borderRadius: '12px',
      border: theme => `2px solid ${theme.palette.colors.neutrals[350]}`,
      wordBreak: 'break-word',
      '&:hover': {
        backgroundColor: theme => theme.palette.white.main,
        boxShadow: '0px 2px 20px 0px rgba(18, 18, 27, 0.15)',
      },
    }}>
    <AiMagic />
    {prompt}
  </Box>
);

const MemoizedDefaultPromptItem = React.memo(DefaultPromptItem, (oldProps, newProps) => oldProps.prompt === newProps.prompt);

export default MemoizedDefaultPromptItem;
